var _style, _line, _line2, _line3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleaningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#00CCFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 19,
    x2: 16,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    y1: 19,
    x2: 19,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22,
    y1: 19,
    x2: 22,
    y2: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,29L23,29c1.3-3.3,2-6.8,2-10.4v-5.1c0-0.8-0.7-1.5-1.5-1.5S22,12.7,22,13.5v-1c0-0.8-0.7-1.5-1.5-1.5 S19,11.7,19,12.5v-1c0-0.8-0.7-1.5-1.5-1.5S16,10.7,16,11.5v1c0-0.8-0.7-1.5-1.5-1.5S13,11.7,13,12.5V20v2.4l-2.5-2.5 c-0.6-0.6-1.5-0.7-2.1-0.2c-0.8,0.6-0.9,1.8-0.2,2.5L15,29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,27c4,0.2,7.3-3,7.3-7c0-1.2-0.3-2.3-0.8-3.3c-0.8-1.5-0.9-3.2-0.4-4.7c0.3-1,0.4-2,0.2-3.1 c-0.5-2.9-2.8-5.2-5.7-5.7c-1.6-0.3-3.2,0-4.5,0.7C18,4.7,16,4.9,14.1,4.3c-1-0.3-2.2-0.4-3.4-0.2C7.9,4.6,5.6,6.9,5.1,9.7 c0,0,0,0.1,0,0.1c-0.5,3.1-1.6,6-3.2,8.8c-0.8,1.4-1.1,3-0.8,4.7c0.5,2.8,2.7,5.1,5.5,5.6c2.5,0.5,4.8-0.3,6.4-1.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningIcon);
export default __webpack_public_path__ + "static/media/cleaning-icon.7b65cdb3e3245deb2a9edde78a263f02.svg";
export { ForwardRef as ReactComponent };